__webpack_require__.p = "/~ghorvath/tudometer/";